import { FC, useEffect, useRef } from 'react';
import { useChannelNotifications } from '../hooks/useChannelNotifications';
import { Children } from '../constants/types/prop.types';

const NotificationProvider: FC<Children> = ({ children }) => {
  const { isConnected } = useChannelNotifications();
  const loggedConnectionRef = useRef<boolean | null>(null);

  useEffect(() => {
    if (loggedConnectionRef.current !== isConnected) {
      loggedConnectionRef.current = isConnected;
    }
  }, [isConnected]);

  // Cleanup on unmount
  useEffect(() => () => {
    loggedConnectionRef.current = null;
  }, []);

  return children;
};

export default NotificationProvider;
